import { Link } from 'react-router';
import { Logo } from '@/components/ui';
import { useMe } from '@/lib/queries';

/** The words and the one way back, the same inside the app frame and outside it. */
function NotFoundBody({ to, label }: { to: string; label: string }) {
  return (
    <div style={{ padding: '40px 16px', maxWidth: 560, width: '100%', margin: '0 auto' }}>
      <h1 style={{ fontSize: 28, fontWeight: 800, letterSpacing: '-.03em', margin: '0 0 8px' }}>
        That page does not exist
      </h1>
      <p className="muted" style={{ fontSize: 15, margin: '0 0 20px', lineHeight: 1.45 }}>
        The address may be mistyped, or the page has moved.
      </p>
      <Link
        to={to}
        className="btn btn-primary hv"
        style={{ width: 'auto', display: 'inline-flex' }}
      >
        {label}
      </Link>
    </div>
  );
}

/** An unknown /app/* address, inside the app frame (the Shell has already signed the host in). */
export function AppNotFound() {
  return <NotFoundBody to="/app" label="Go to the app →" />;
}

/** Any other unknown address: back to the app when signed in, to the landing page when not. */
export function NotFound() {
  const signedIn = !!useMe().data?.user;
  return (
    <div className="screen">
      <div className="topbar">
        <Logo to={signedIn ? '/app' : '/'} />
      </div>
      <NotFoundBody
        to={signedIn ? '/app' : '/'}
        label={signedIn ? 'Go to the app →' : 'Go to the home page →'}
      />
    </div>
  );
}
